import React, { ReactNode } from "react";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";
import { ChevronDown } from "../icons";

type Props = {
  header: ReactNode;
  body: ReactNode;
  isOpen: boolean;
  onToggleIsOpen: () => void;
  headerStyles?: string;
};

export const Accordion: React.FC<Props> = ({
  header,
  body,
  isOpen,
  onToggleIsOpen,
  headerStyles,
}) => {
  return (
    <div className="overflow-x-hidden">
      <button
        onClick={onToggleIsOpen}
        className={twMerge(
          classNames(
            "flex w-full items-center justify-between py-3 text-left transition-all",
            headerStyles,
          ),
        )}
      >
        <div>{header}</div>
        <ChevronDown
          className={classNames("w-4 transition-transform duration-300", {
            "rotate-180": isOpen,
          })}
        />
      </button>

      <div
        className={classNames(
          "text-sm overflow-x-hidden overflow-y-hidden transition-all duration-300",
          {
            "visible pb-4 opacity-100": isOpen,
            "collapse h-0 pb-0 opacity-0": !isOpen,
          },
        )}
      >
        {body}
      </div>
    </div>
  );
};
